<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.74292 12.2427L12.2282 3.75739" stroke="currentcolor" stroke-width="2" stroke-linecap="round" />
    <path d="M12.228 12.2427L3.74275 3.75739" stroke="currentcolor" stroke-width="2" stroke-linecap="round" />
  </svg>
</template>
